<template>
  <v-card>

    <v-data-table :headers="headers"
                  v-model="selected"
                  :search="form.search"
                  :items="filteredUsers"
                  :items-per-page="10"
                  :footer-props="{'items-per-page-options': [5, 10, 25, 50]}"
                  :loading="loading"
                  loading-text="Loading users...">

      <template v-slot:top="data">
        <div class="d-flex justify-space-between px-2 py-2">
          <filter-users-menu :form="form">
          </filter-users-menu>
        </div>
      </template>

      <template v-slot:item.slug="{item: user}">
        <router-link :to="{name: isAdmin ? 'admin.user.edit' : 'admin.user.show', params: {userID: user.id}}"
                     class="text-no-wrap">
          {{ user.name }}
        </router-link>
      </template>

      <template v-slot:item.manager_name="{item: user}">
        {{ user.manager_name }}
      </template>

      <template v-slot:item.groups="{item: user}">
        <v-menu tile>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon
                   v-bind="attrs"
                   v-on="on">
              <v-icon>
                fal fa-ellipsis-v
              </v-icon>
            </v-btn>
          </template>
          <v-list flat
                  tile
                  :elevation="0">
            <v-list-item v-for="group in user.groups"
                         :key="group.id"
                         :to="{name: 'group.edit', params: {groupID: group.id}}">
              <v-list-item-content>
                <v-list-item-title>
                  {{ group.name }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="user.groups.length === 0">
              <v-list-item-content>
                <v-list-item-title>
                  No groups
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>

      <template v-slot:item.status="{item: user}">
        <div class="d-flex justify-center">
          <v-icon v-if="!user.is_email_verified"
                  color="orange"
                  title="Has not verified email address and set a password">
            fas fa-exclamation-triangle
          </v-icon>
          <v-icon v-else-if="user.is_active"
                  color="success">
            fas fa-check-circle
          </v-icon>
          <v-icon v-else
                  color="error">
            fas fa-times-circle
          </v-icon>
        </div>
      </template>

      <template v-slot:item.created_at="{item: user}">
        {{ user.created_at | datetime('MMM D, YYYY') }}
      </template>
      <template v-slot:item.last_login_at="{item: user}">
        <template v-if="user.last_login_at">
          {{ user.last_login_at | datetime('MMM D, YYYY') }}
        </template>
        <template v-else>
          Never
        </template>
      </template>

    </v-data-table>

  </v-card>
</template>
<script>
import {Form} from 'vform';
import {mapGetters} from 'vuex';
import RefreshButton from "../../../components/RefreshButton";
import dataService from "../../../../../ml/services/dataService";
import FilterUsersMenu from "./FilterUsersMenu";

export default {
  components: {FilterUsersMenu, RefreshButton},
  props: {
    loading: {
      type: Boolean,
      required: false,
    },
    users: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {
      dialog: false,
      form: new Form({
        email: '',
        group_id: '',
        name: '',
        role: '',
        search: '',
        status: 'Active',
        manager_id: '',
      }),
      headers: [
        {text: 'Name', value: 'slug', filterable: true,},
        {text: 'Email', value: 'email', filterable: true,},
        {text: 'Role', value: 'team.role_name', filterable: true,},
        {text: 'Groups', value: 'groups', filterable: false,},
        //{text: 'Phone', value: 'phone',},
        {text: 'Manager', value: 'manager_name'},
        {text: 'Region', value: 'region',},
        //{text: 'District', value: 'district',},
        //{text: 'Territory', value: 'territory',},
        {text: 'Created', value: 'created_at',},
        {text: 'Last Signin', value: 'last_login_at',},
        {text: 'Active', value: 'status',},
        {text: '', value: 'data-table-expand'},
      ],
      selected: [],
    }
  },
  computed: {
    ...mapGetters([
      'groups',
      'isAdmin',
      'isMember',
    ]),
    filteredUsers() {
      const form = this.form;
      return this.users.filter(u => {
        if (form.status && u.status !== form.status) {
          return false;
        }
        if (form.name && !u.name.toLowerCase().includes(form.name.toLowerCase())) {
          return false;
        }
        if (form.email && !u.email.toLowerCase().includes(form.email.toLowerCase())) {
          return false;
        }
        if (form.region && !u.region) {
          return false;
        }
        if (form.region && !u.region.toLowerCase().includes(form.region.toLowerCase())) {
          return false;
        }
        if (form.role && u.team.role !== form.role) {
          return false;
        }
        if (form.group_id && !u.groups.map(g => g.id).includes(form.group_id)) {
          return false;
        }
        if (form.manager_id && u.manager_id !== form.manager_id) {
          return false;
        }
        return true;
      });
    }
  },
  methods: {}
}
</script>
